import styled from 'styled-components';
import { MessageMedium } from 'constants/messageMediums';
import { Subtitle1, colors, spacing } from 'ui/theme';
import { Link } from 'ui/links';
import { lowerCaseMessageMedium } from 'modules/frequencyManagement/lib/utils/mediumDomainUtils';
import { Body2Light } from '../Content.styles';

const Wrapper = styled.div`
  align-items: center;
  background: ${colors.backgroundSecondary};
  display: flex;
  flex-direction: column;
  padding: ${spacing.x6} ${spacing.x5} ${spacing.x6} ${spacing.x5};
  text-align: center;
`;

export const NoneExistEmptyState = ({ messageMedium }: { messageMedium: MessageMedium }) => (
  <Wrapper>
    <Subtitle1>There are no {lowerCaseMessageMedium(messageMedium)} message types</Subtitle1>
    <Body2Light>
      <Link href={`/settings/channels/${messageMedium}`} size="body2">
        Go to {messageMedium} Message Channels and Types
      </Link>{' '}
      or learn more by visiting our{' '}
      <Link
        href="https://support.iterable.com/hc/en-us/articles/204780529-Message-Channels-and-Message-Types-Overview"
        size="body2"
      >
        Knowledge Center
      </Link>
      .
    </Body2Light>
  </Wrapper>
);
